import { GAME_ID, REDUX_ACTIONS } from 'a/sortItOut/data/constants';

const initialState = {
  layout: {},
  dropAnimationStarted: false,
};

const displayReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_LAYOUT:
      return {
        ...initialState,
        layout: action.payload.layout,
      };
    case REDUX_ACTIONS.SET_DROP_ANIMATION_STARTED:
      return {
        ...state,
        dropAnimationStarted: action.payload.dropAnimationStarted,
      };
    default:
      return state;
  }
};

export default displayReducer;
